import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';

export default function CustomPieChart({ pTGCBurned, pTGCLiquidity, pTGCStake, pTGCLock, pTGCHold }) {
  const data = [
    { id: 0, value: pTGCBurned === 0 ? 1 : pTGCBurned, name: "PTGC Burned", shortname: "Burned", supply: "1.2M", marketCap: "30M", color: "url(#a1)" },
    { id: 1, value: pTGCLiquidity === 0 ? 1 : pTGCLiquidity, name: "PTGC Liquidity", shortname: "Liquidity", supply: "950K", marketCap: "24M", color: "url(#a2)" },
    { id: 2, value: pTGCHold === 0 ? 1 : pTGCHold, name: "PTGC Hold", shortname: "Hold", supply: "800K", marketCap: "18M", color: "url(#a3)" },
    { id: 3, value: pTGCStake === 0 ? 1 : pTGCStake, name: "PTGC Staked", shortname: "Staked", supply: "600K", marketCap: "14M", color: "url(#a4)" },
    { id: 4, value: pTGCLock === 0 ? 1 : pTGCLock, name: "PTGC Staked & Locked", shortname: "Stake & Locked", supply: "500K", marketCap: "12M", color: "url(#a5)" },
  ];

  const totalValue = data.reduce((sum, d) => sum + d.value, 0);

  const CustomTooltip = ({ item }) => {
    if (!item) return null;
    return (
      <Box sx={{ backgroundColor: "#fff", padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold">{item.name}</Typography>
        <Typography variant="body2">Supply: {item.supply}</Typography>
        <Typography variant="body2">Market Cap: {item.marketCap}</Typography>
      </Box>
    );
  };

  return (
    <Box className='piechartHandle' position="relative" width={700} height={500}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fontWeight: 'normal',   // lighter weight
          fontSize: 12,           // smaller font size
          fill: '#222',           // text color
          textAnchor: 'middle',   // center text
          whiteSpace: 'pre-line'  // allow line breaks (\n)
        }
      }}
    >{/* Gradient Definitions */}
      <svg width="0" height="0">
        <defs>
          <linearGradient id="a1" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#d4af37" />
            <stop offset="100%" stopColor="#f9e79f" />
          </linearGradient>
          <linearGradient id="a2" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#f5b041" />
            <stop offset="100%" stopColor="#f8c471" />
          </linearGradient>
          <linearGradient id="a3" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#e59866" />
            <stop offset="100%" stopColor="#fad7a0" />
          </linearGradient>
          <linearGradient id="a4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#edbb99" />
            <stop offset="100%" stopColor="#ffe699" />
          </linearGradient>
          <linearGradient id="a5" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#d5f5e3" />
            <stop offset="100%" stopColor="#f7dc6f" />
          </linearGradient>
        </defs>
      </svg>
      <PieChart
        width={700}
        height={500}
        series={[
          {
            data: data.map(d => ({
              id: d.id,
              value: d.value,
              label: d.shortname,
              color: d.color,
              ...d,
            })),
            innerRadius: 80,
            outerRadius: 200,
            paddingAngle: 5,
            cornerRadius: 4,
            cx: 350,
            cy: 250,
            slices: { stroke: "#c9b165", strokeWidth: 2 },
            highlightScope: { faded: 'global', highlighted: 'item' },
            faded: { additionalRadius: -30, color: 'gray' },
            arcLabel: (d) => {
              const percent = ((d.value / totalValue) * 100).toFixed(1);
              return `${d.label}\n${percent}%`; // line break between name and percentage
            },
          },
        ]}
        slotProps={{
          legend: { hidden: true },
          tooltip: { trigger: 'item', content: ({ item }) => <CustomTooltip item={item} /> }
        }}
      />
    </Box>
  );
}
